import { Route } from '@angular/router';
import {SuppliersTabsResolver, TenderLastRoundsSuppliersResolver} from '../../../resolvers';
import { TenderSuppliersComponent } from '../../../../pages';

export const tenderSuppliersRoute: Route = {
    path: 'suppliers',
    component: TenderSuppliersComponent,
    //canActivate: [TenderStatusGuard],
    resolve: {
        availableTabs: SuppliersTabsResolver,
        suppliers: TenderLastRoundsSuppliersResolver
    }
};
